import ModalBasicLayout from "./ModalBasicLayout";
import FeatureAddonUnpaidPaywall from "../FeatureAddons/FeatureAddonUnpaidPaywall";
import { FEATURE_ADDON_KEYS } from "../../actions/featureAddons";
import Templates from "../../pages/Templates/Templates";
import { useTemplatesModals } from "../../contexts/templatesModalsContext";
import { useTranslationApp } from "../../lib/i18next";
import { TEMPLATES_TITLE } from "../../i18n/keysTranslations";

const ModalTemplates = ({ modalOpen, onCloseModal }) => {
  const { t } = useTranslationApp();
  const { openTemplateEditor, openTemplateProduce } = useTemplatesModals();

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      fullScreen={true}
      maxWidth={false}
      fullWidth={true}
      hasTitle={false}
      ariaLabel={t(TEMPLATES_TITLE)}
      sxContent={{
        p: 0,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100vh",
        maxHeight: "100vh",
        overflow: "auto",
      }}
      sxPaper={{
        height: "100vh",
        maxHeight: "100vh",
      }}
    >
      <FeatureAddonUnpaidPaywall addonKey={FEATURE_ADDON_KEYS.TEMPLATES} />
      <Templates
        onOpenEditor={({ templateID, isProvisionalCreate }) =>
          openTemplateEditor({ templateID, isProvisionalCreate })
        }
        onOpenProduce={({ templateID, produceID }) =>
          openTemplateProduce({ templateID, produceID })
        }
        onCloseModal={onCloseModal}
      />
    </ModalBasicLayout>
  );
};

export default ModalTemplates;
